























import { defineComponent } from '@vue/composition-api';
import QuotaStepInfo from '../quota-step-info/index.vue';

const name = 'ttam-ios14-info-quota-detail-container';
export default defineComponent({
  name,
  components: { QuotaStepInfo },
  props: {
    title: { type: String, default: '-' },
    content: { type: String, default: '-' },
    showStep: { type: Boolean, default: true },
    showDivider: { type: Boolean, default: true },
    canHover: { type: Boolean, default: true },
  },

  setup() {
    return {
      name,
    };
  },
});
